<template>
  <div v-if="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Chargement...</span>
    </div>
    <p class="mt-2">Chargement des types de chambre...</p>
  </div>

  <div v-else>
    <!-- Breadcrumb -->
    <div class="breadCrumb">
      <div><h3>Types de Chambre</h3></div>
      <div>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Configurations</li>
            <li class="breadcrumb-item active" aria-current="page">Types de Chambre</li>
          </ol>
        </nav>
      </div>
    </div>

    <data value="">
      <!-- Actions -->
      <div class="tab-top">
        <div class="d-flex justify-content-end gap-2">
          <!-- Bouton Création -->
          <button class="btn btn-primary" @click="creation()">
            <i class="bi bi-plus-circle"></i> Création
          </button>

          <!-- Dropdown actions -->
          <div class="dropdown">
            <button
              class="btn btn-outline-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Actions
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li><a class="dropdown-item" href="#" @click.prevent="">Exporter</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Tableau -->
      <div class="card p-3">
        <div class="row">
          <div class="d-flex justify-content-end">
            <!-- Recherche -->
            <div class="col-md-2 m-2">
              <div class="form-group">
                <label class="form-label" for="search">Rechercher</label>
                <input
                  type="text"
                  id="search"
                  v-model="searchQuery"
                  placeholder="Rechercher un type..."
                  class="form-control"
                >
              </div>
            </div>

            <!-- Items par page -->
            <div class="col-md-2 m-2">
              <div class="form-group">
                <label class="form-label">Items par page</label>
                <select v-model="itemsperpage" class="form-select">
                  <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
                </select>
              </div>
            </div>

            <!-- Trier par -->
            <div class="col-md-3 m-2">
              <div class="form-group">
                <label class="form-label">Order</label>
                <select v-model="orderBy" class="form-select">
                  <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-2 m-2">
              <div class="form-group">
                <label class="form-label">Trier par</label>
                <select v-model="sortOrder" class="form-select">
                  <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Tableau -->
        <div class="table-responsive">
          <table class="table table-hover table-bordered">
            <thead class="table-primary">
              <tr>
                <th>#</th>
                <th>Date création</th>
                <th>Libellé</th>
                <th>Tarif journalier</th>
                <th>Statut</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(type, index) in filteredTypes" :key="type.id">
                <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
                <td>{{ formatDate(type.createdAt) }}</td>
                <td>{{ type.nom }}</td>
                <td>{{ type.tarifParJour }} F CFA</td>
               <td>
  <span v-if="type.isEnabled" class="badge bg-success">Activé</span>
  <span v-else class="badge bg-secondary">Désactivé</span>
</td>
                <td class="text-center">
                  <div class="dropdown">
                    <button 
                      class="btn btn-sm btn-outline-primary dropdown-toggle" 
                      type="button" 
                      data-bs-toggle="dropdown" 
                      aria-expanded="false"
                    >
                      ⋮
                    </button>
                    <ul class="dropdown-menu">
                      <li><a class="dropdown-item" @click="modifier(type.id)">Modifier</a></li>
                      <li><a class="dropdown-item text-danger" @click="supprimer(type.id)">Supprimer</a></li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr v-if=" typeChambre ? typesChambre.length === 0 : 0">
                <td colspan="6" class="text-center">Aucune donnée disponible</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <nav>
          <ul class="pagination justify-content-end">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
            </li>

            <li
              v-for="page in totalPages"
              :key="page"
              class="page-item"
              :class="{ active: page === currentPage }"
            >
              <button class="page-link" @click="changePage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
              <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
            </li>
          </ul>
        </nav>
      </div>
    </data>
  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      isLoading: true,
      isFirstLoad: true,
      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'tch.createdAt',
      sortOrder: 'desc',
      typesChambre: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [2, 4, 6, 10],
      orderByTabs: {
        nom: 'tch.nom',
        tarif: 'tch.tarifParJour',
        creation: 'tch.createdAt',
        modification: 'tch.updatedAt'
      },
      sortOrders: {
        croissant: 'asc',
        decroissant: 'desc'
      }
    };
  },
  computed: {
    filteredTypes() {
      if (!this.searchQuery) {
        return this.typesChambre;
      }
      return this.typesChambre.filter(type =>
        type.nom.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('DD-MM-YYYY HH:mm');
    },
    creation() {
      this.$router.push({ name: 'create_type_chambre' });
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
      this.getTypesChambre();
    },
    async getTypesChambre() {
      if (this.isFirstLoad) {
        this.isLoading = true;
        this.isFirstLoad = false;
      }
      try {
        const response = await api.getItems('type_chambres', {
          orderBy: this.orderBy,
          itemsperpage: this.itemsperpage,
          sortOrder: this.sortOrder,
          page: this.currentPage,
          search: this.searchQuery
        });

        const { data, meta } = response.data;
        
        this.typesChambre = data;

        console.log(this.typesChambre);
       
        this.totalItems = meta?.total_records || 0;
      } catch (error) {
        console.error('Erreur lors de la récupération des types de chambre:', error);
      } finally {
        this.isLoading = false;
      }
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_chambres', params: { id } });
    },
    async supprimer(id) {
      try {
        const confirmation = window.confirm("Êtes-vous sûr de vouloir supprimer ce type de chambre ?");
        if (!confirmation) return;
        this.isLoading = true;
        await api.deleteItem('type_chambres', id);
        this.getTypesChambre();
      } catch (error) {
        alert("Une erreur s'est produite lors de la suppression.");
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.getTypesChambre();
    },
    itemsperpage() {
      this.currentPage = 1;
      this.getTypesChambre();
    },
    orderBy() {
      this.getTypesChambre();
    },
    sortOrder() {
      this.getTypesChambre();
    }
  },
  created() {
    this.getTypesChambre();
  }
};
</script>

<style scoped>
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.pagination .page-item .page-link {
  color: #007bff;
}
.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
</style>
